import { Button as ButtonAntD, Row } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 24px;
`;

export const DynamicPricingWrapper = styled(Row)<{ dynamicPricingEnabled?: boolean }>`
  border: ${({ dynamicPricingEnabled }) => (!dynamicPricingEnabled ? `1px solid ${COLORS.lightDarkText}` : 'none')};
  border-radius: 3px;
  padding: 16px 24px;
  gap: 16px;
  font-weight: 300;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  background-color: ${({ dynamicPricingEnabled }) => (dynamicPricingEnabled ? '#f3f4f6' : '#fff')};
`;

export const CheckWrapper = styled.div`
  font-weight: 300;
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const DynamicPricingSwitchWrapper = styled(Row)`
  align-items: center;
  gap: 16px;
  position: relative;
`;

export const DynamicPricingConfigurationContainer = styled(DynamicPricingWrapper)``;

export const DynamicPricingConfigLabel = styled.div`
  cursor: pointer;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
  color: ${COLORS.black};

  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'apple color emoji', 'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
`;

export const DynamicPricingConfigurationTitle = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const Value = styled.div`
  color: #000;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const RoundedButton = styled(ButtonAntD)`
  display: flex;
  height: 40px;
  width: 40px;
  border-radius: 32px;
  padding: 8px;
  align-self: flex-end;

  margin-bottom: 4px;
  align-items: center;
  justify-content: center;
  margin-right: 24px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const ThrashButton = styled(RoundedButton)`
  margin-right: 0px;
  &.ant-btn-primary {
    background-color: #f3f4f6;
    border-color: #f3f4f6;
  }
`;
